import { ActionIcon, CopyButton as MantineCopyButton, Tooltip } from '@mantine/core';

import { IconCheck, IconCopy } from '@tabler/icons-react';

export const CopyButton = ({ value }: { value: string }) => {
	return (
		<MantineCopyButton value={value} timeout={2000}>
			{({ copied, copy }) => (
				<Tooltip
					label={copied ? 'Скопировано' : 'Скопировать ссылку'}
					position="top"
					zIndex={2000}
					withArrow
				>
					<ActionIcon
						bg="white"
						radius="lg"
						color={copied ? 'teal' : 'gray'}
						variant="subtle"
						onClick={copy}
					>
						{copied ? <IconCheck size={20} /> : <IconCopy size={20} />}
					</ActionIcon>
				</Tooltip>
			)}
		</MantineCopyButton>
	);
};
